import {
  FormField,
  FormItem,
  FormLabel,
  FormControl,
  FormMessage,
} from '@/components/ui/form';
import { RadioGroup, RadioGroupItem } from '@/components/ui/radio-group';
import { PlannerConfigEntityWithOptionalFields } from '@/services/configurator/PlannerConfigTypes';
import { Control } from 'react-hook-form';

type RadioFields = 'team';

type FormRadioGroupComponentProps = {
  formControl: Control<PlannerConfigEntityWithOptionalFields>;
  name: RadioFields;
  formLabel: string;
  radioItems: Array<{ name: string; value: string }>;
};

function FormRadioGroupComponent({
  formControl,
  name,
  formLabel,
  radioItems,
}: FormRadioGroupComponentProps) {
  return (
    <FormField
      control={formControl}
      name={name}
      render={({ field }) => (
        <FormItem className='space-y-3'>
          <FormLabel>{formLabel}</FormLabel>
          <FormControl>
            <RadioGroup
              {...field}
              onValueChange={(value) => {
                field.onChange(value);
              }}
              className='flex flex-col space-y-1'
            >
              {radioItems.map((item) => (
                <FormItem
                  className='flex items-center space-x-3 space-y-0'
                  key={item.name}
                >
                  <FormControl>
                    <RadioGroupItem value={item.value} />
                  </FormControl>
                  <FormLabel className='font-normal'>{item.name}</FormLabel>
                </FormItem>
              ))}
            </RadioGroup>
          </FormControl>
          <FormMessage />
        </FormItem>
      )}
    />
  );
}

export default FormRadioGroupComponent;
